import { useNavigate } from "react-router-dom";
import { useUserPermissions } from "../../../hooks/useUserPermissions";

export const useInicioTemplate = () => {
  const navigate = useNavigate();
  const { userStorageData } = useUserPermissions();

  const primeiroNome = userStorageData?.nome?.split(" ")[0];

  function handleMeusAgendamentos() {
    navigate("/meus-agendamentos");
  }

  function handleNovoAgendamento() {
    navigate("/agendamento");
  }

  return { primeiroNome, handleMeusAgendamentos, handleNovoAgendamento };
};
